import { Route, Switch } from "react-router-dom";
import { url } from "lcm-iot-commons";

import Legal from "./LegalHTMLfiles/Legal";
import Imprint from "./LegalHTMLfiles/Imprint";
import LegalMarkdownContainer from "./LegalMarkdownContainer";
import { masterServiceAgreement2025 } from "./LegalMarkdownContent/masterServiceAgreement2025";
import { serviceLevelAgreement2025 } from "./LegalMarkdownContent/serviceLevelAgreement2025";
import { privacyPolicy2025 } from "./LegalMarkdownContent/privacyPolicy2025";
import { securityPolicy2025 } from "./LegalMarkdownContent/securityPolicy2025";
import { acceptableUsePolicy2025 } from "./LegalMarkdownContent/acceptableUsePolicy2025";
import { dataLocalizationPolicy2025 } from "./LegalMarkdownContent/dataLocalizationPolicy2025";
import { definitionNetilionConnect2025 } from "./LegalMarkdownContent/definitionNetilionConnect2025";
import { definitionNetilionOne2025 } from "./LegalMarkdownContent/definitionNetilionOne2025";
import { definitionProcessWater2025 } from "./LegalMarkdownContent/definitionProcessWater2025";

export default function LegalRoutesIndia() {
  return (
    <div className="legal-india">
      <Switch>
        <Route path={url("/legal")} component={Legal} exact />
        <Route
          path={url("/legal/master-service-agreement")}
          render={() => (
            <LegalMarkdownContainer content={masterServiceAgreement2025} />
          )}
          exact
        />
        <Route
          path={url("/legal/service-level-agreement")}
          render={() => (
            <LegalMarkdownContainer content={serviceLevelAgreement2025} />
          )}
          exact
        />
        <Route
          path={url("/legal/privacy-policy")}
          render={() => <LegalMarkdownContainer content={privacyPolicy2025} />}
          exact
        />
        <Route
          path={url("/legal/security-policy")}
          render={() => <LegalMarkdownContainer content={securityPolicy2025} />}
          exact
        />
        <Route
          path={url("/legal/acceptable-use-policy")}
          render={() => (
            <LegalMarkdownContainer content={acceptableUsePolicy2025} />
          )}
          exact
        />
        <Route
          path={url("/legal/data-localization-policy")}
          render={() => (
            <LegalMarkdownContainer content={dataLocalizationPolicy2025} />
          )}
          exact
        />
        <Route
          path={url("/legal/definition-netilion-connect")}
          render={() => (
            <LegalMarkdownContainer content={definitionNetilionConnect2025} />
          )}
          exact
        />
        <Route
          path={url("/legal/definition-netilion-one")}
          render={() => (
            <LegalMarkdownContainer content={definitionNetilionOne2025} />
          )}
          exact
        />
        <Route
          path={url("/legal/definition-netilion-process-water")}
          render={() => (
            <LegalMarkdownContainer content={definitionProcessWater2025} />
          )}
          exact
        />
        <Route path={url("/legal/terms-of-service")} component={Legal} exact />
        <Route path={url("/legal/imprint")} component={Imprint} exact />
      </Switch>
    </div>
  );
}
